import { createI18n } from 'vue-i18n';

import en from '~/i18n/en.json';
import fr from '~/i18n/fr.json';

const i18n = createI18n({
	locale: 'fr', // set locale
	fallbackLocale: 'fr', // set fallback locale
	globalInjection: true,
	legacy: false, // use composition API
	warnHtmlMessage: false, // remove XSS warning due to HTML in translation values
	messages: {
		en,
		fr
	}
});

export { i18n };
